import { atom } from "recoil";
import { CFDStatus } from "features/cfd/state/cfdAtoms";

// ユーザがLIMEタブのドロップダウンでマウスオーバーしている最適化CFD
export const hoveredOptCFDidState = atom<string | null>({
  key: "hoveredOptCFDidState",
  default: null,
});

// ユーザがドロップダウンで選択したcfd_id
export const selectedOptCFDState = atom<CFDStatus | null>({
  key: "selectedOptCFDState",
  default: null,
});
